import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ticketCarCardOrderServices from '@src/services/ticketCarCardOrder.services';

export const getCardApprovalList = createAsyncThunk(
  'getCardApprovalList',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      const card = await ticketCarCardOrderServices.getCardApprovalList({ customerId });

      return card;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const updateCardApproval = createAsyncThunk(
  'updateCardApproval',
  async (body, { getState, rejectWithValue }) => {
    try {
      const card = await ticketCarCardOrderServices.updateCardApproval({
        vehicleDetailId: body?.vehicleDetailId,
      });
      return card;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  loading: {
    cardOrderList: false,
    updateCardOrderList: false,
  },
  cardOrderList: [],
  updateCardOrderList: false,
};

export const ticketCarCardOrderSlice = createSlice({
  name: 'ticketCarCardOrder',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCardApprovalList.pending, (state, action) => {
        state.loading.cardOrderList = true;
        state.updateCardOrderList = false;
      })
      .addCase(getCardApprovalList.fulfilled, (state, action) => {
        state.loading.cardOrderList = false;
        state.updateCardOrderList = false;

        state.cardOrderList = action?.payload?.data || [];
      })
      .addCase(getCardApprovalList.rejected, (state) => {
        state.loading.cardOrderList = false;
        state.updateCardOrderList = false;

        state.cardOrderList = [];
      })
      .addCase(updateCardApproval.pending, (state, action) => {
        state.loading.updateCardOrderList = true;
        state.updateCardOrderList = false;
      })
      .addCase(updateCardApproval.fulfilled, (state, action) => {
        state.loading.updateCardOrderList = false;

        state.updateCardOrderList = action?.payload?.isSuccess || [];
      })
      .addCase(updateCardApproval.rejected, (state) => {
        state.loading.updateCardOrderList = false;

        state.updateCardOrderList = false;
      });
  },
});
